export default {
  'page-title': 'การบริหารจัดการวันลาออนไลน์ - ปฏิทินผู้อนุมัติ',
  title: 'ปฏิทินผู้อนุมัติ',
  'leave-type-legend': 'ประเภทการลา:',
  'status-legend': 'สถานะ:',
  'detail-title': 'รายละเอียดการขอลา'
}
